import { configureStore, combineReducers } from '@reduxjs/toolkit';
import blogReducer from '../features/blog/slices/blog.slice';
import contactReducer from '../features/contact/slices/contact.slice';
import jobsReducer from '../features/jobs/slices/jobs.slice';

const appReducer = combineReducers({
  blog: blogReducer,
  contact: contactReducer,
  jobs: jobsReducer,
});

const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
